import React from "react";
import Layout from "./Layout";
import { Routes, Route } from "react-router-dom";
import { PageLoader } from "./page-loader";
import { AuthenticationGuard } from "./authentication-guard";
import { useAuth0 } from "@auth0/auth0-react";
import HomePage from "./home/HomePage";
import PageNotFound from "./PageNotFound";
import UserPage from "./profile/UserPage";
import NetworkProfile from "./network/NetworkProfile";
import NetworkPage from "./network/NetworkPage";
import CalendarPage from "./calendar/CalendarPage";
import EventListPage from "./events/EventListPage";
import EventPage from "./events/EventPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Callback from "./auth/Callback";

export default function App() {
  const { isLoading } = useAuth0();

  if (isLoading) {
    return (
      <div className="page-layout">
        <PageLoader />
      </div>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/callback" element={<Callback />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route
          path="/profile"
          element={<AuthenticationGuard component={UserPage} />}
        />
        <Route
          path="/profile/:id"
          element={<AuthenticationGuard component={NetworkProfile} />}
        />
        <Route
          path="/network"
          element={<AuthenticationGuard component={NetworkPage} />}
        />
        <Route path="/eventlist" element={<EventListPage />} />

        <Route path="/event/:id?" element={<EventPage />} />
        <Route element={<PageNotFound />} />
      </Routes>
      <ToastContainer autoClose={300} hideProgressBar theme="colored" />
    </Layout>
  );
}
